import React from 'react';
import { Backdrop } from '@mui/material';
import { useTheme } from '@qbe/ads-core';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import qbeLogoIcon from '../../assets/images/qbe-logo-icon-contain-76x70.png';

const rotateScaleDown = keyframes`
0% {
  transform: scale(1) rotateZ(0);
  opacity: 1;
}

50% {
  transform: scale(0.5) rotateZ(180deg);
}

100% {
  transform: scale(1) rotateZ(360deg);
  opacity: 0;
}
`;

const StyledImg = styled.img`
  animation: ${rotateScaleDown} 1s linear infinite;
  height: 70px;
`;

const Loading = ({ show = true }) => {
  const theme = useTheme();

  return (
    <Backdrop
      sx={{
        zIndex: theme.zIndex.appBar + 1,
        backgroundColor: 'rgba(0,0,0,0.5)',
      }}
      open={show}
    >
      <StyledImg src={qbeLogoIcon} alt="Loading" />
    </Backdrop>
  );
};

export default Loading;
